export const favDiamension = [
  {
    actionFavorites: [
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-09T16:44:17.638Z",
        point:
          "Learn to appreciate less enthusiastic or energetic states, so you become more state independent",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "ACTION",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-09T16:44:17.638Z",
        _id: "63bc4461fec027cb7857280e",
      },
    ],
    description: [
      "This score indicates your current tendency to be warm, sociable, and friendly as opposed to being shy, distant, and unfriendly. It measures how consistently you do actions like appreciating others, hugging or other forms of physical gestures, or making time to have deep conversations with friends and family.",
    ],
    descriptionDetails:
      "<p>What might be potential growth areas / blind spots?</p><ol><li>How to manage your energy well throughout the day?</li><li>How to balance zest with wisdom and prudence?</li><li>How to cultivate tranquil energy and enthusiasm</li><li>How to prevent overexcitement leading to overpromising and underdelivering?</li><li>How to figure out your optimal energy levels for different tasks?</li><li>How to become more grounded, stable, and steady emotionally?</li><li>How to be aware of your own energy levels in order not to deplete yourself too much? (e.g., starting strong is good, but finishing strong is much more important)</li><li>How to avoid expressing too much energy and enthusiasm that might feel inappropriate to others?</li><li>How to make your enthusiasm more grounded and calm?</li><li>How to adjust your energy level when other people are in a less enthusiastic and energetic state?</li><li>How to deal with disappointment if a project you’ve been enthusiastic about didn’t work out and what to learn from this?</li><li>How to avoid draining other people’s energy with your enthusiasm?</li><li>How to combine enthusiasm, strategic thinking, and sound prioritisation?</li><li>How to know when mirroring someone's emotions and states is more appropriate than being energetic and enthusiastic?</li><li>How to combine enthusiasm with seriousness to ensure that your competence is not belittled?</li><li>How to channel enthusiasm in a positive direction by focusing on the most important goals instead of “getting things done”?</li><li>How to better manage impulsive behaviour?</li><li>How to maintain your enthusiasm in times of setbacks and disappointments?</li><li>How to become less reckless with decisions and actions during periods of high enthusiasm?</li><li>How to be more aware of the situations where you might want to tone down your zest and enthusiasm?</li><li>How to know when less enthusiasm is required, and a more neutral attitude is called for? (e.g., in a serious business meeting)</li><li>How to prevent enthusiasm from taking away the necessary focus and discipline?</li></ol><p>What actions lead to progress here?</p><ol><li>Keep a journal to collect situations with other people where your energy and enthusiasm were not well-calibrated to the emotional state of the other person</li><li>Reflect on past situations where (1) you were too enthusiastic about something and (2) this enthusiasm led to negative consequences</li><li>Remind yourself that disappointment (and enthusiasm) is a fleeting feeling</li><li>Learn to appreciate less enthusiastic or energetic states, so you become more state independent</li><li>Observe the energy and enthusiasm of others before speaking or acting to modulate your level</li><li>Analyze the project that you’ve been enthusiastic about but didn’t work out and examine how those experiences can improve your future decision-making</li><li>When you are in a high energy and enthusiasm state, try to add some grounded and calm energy </li><li>Start an energy and enthusiasm log to see if you calibrated them well throughout the day</li><li>Become more aware of the relationship between your enthusiasm, professionalism, and perceived competence</li><li>Create a list of situations where being more neutral and sober would have been more useful</li><li>Specify the level of energy you prefer for different tasks: low, medium, high? Which task works best with which level? Why? </li><li>Make a list of “reckless” decisions from the past that could have been made more prudently if you had toned down your zest and enthusiasm </li><li>Design a system that helps you decide when it is better to be more neutral than very excited about something</li><li>Make it a habit to evaluate your decisions after 3 days if they were based on high levels of energy and enthusiasm </li><li>Reflect on past situations where your enthusiasm has led to overpromising and underdelivering</li><li>Create a list of situations where more neutral and grounded energy is called for (1) at work, (2) when interacting with family members, and (3) when socializing with friends</li><li>List more consequences of an overly enthusiastic attitude: (1) you might not be taken seriously as a competent professional, (2) your expectations might have been set too high for yourself or others, which is draining and demotivating over time, (3) your decisions might have been based on insufficient information leading to poor choices</li><li>Create two categories: one for things that are important but not urgent/immediate/time-sensitive and one for things that are urgent/immediate/time-sensitive. Keep the former in mind when feeling overexcited. For the latter case make sure that they get done in a timely manner without compromising quality </li><li>Consider a “calm energy” training where you focus on cultivating more serenity, stability, and equanimity</li><li>Read more about managing energy like this article: How To Manage Your Energy</li></ol><p><br></p>",
    detailedDescription: [
      "Your moderate score indicates that you might be more often affectionate, pleasant, and hospitable than cold, insincere, and disagreeable. \n\nYou often believe that you can trust your friends, and they know they can trust you too. You experience many warm and trusting relationships with others and sometimes maintain close friendships through the years. Once in a while, you enjoy personal and mutual conversations with family members or friends. \n\nOther people might often feel warm when they interact with you. You might have strong feelings of empathy and affection in your relationships and value the importance of having positive relations with others. You might tend to value and emphasize the achievement of close unions with others and also guide them from time to time.",
    ],
    detailedDescriptionDetails: [
      {
        createdAt: "2022-07-14T10:22:02.106Z",
        heading: "What might be potential growth areas / blind spots?",
        points: [
          "How to have positive relationships with the people around you?",
          "How to develop empathy when listening to other people’s concerns?",
          "How to maintain close relationships with others through the years?",
          "How to take care of yourself while allowing yourself to be a thoughtful person?",
          "How to express your affection in your relationship…d deepen your connection with family and friends?",
        ],
        updatedAt: "2022-07-14T10:22:02.106Z",
        _id: "62cfee4afdcd13520118c580",
      },
      {
        createdAt: "2022-07-14T10:22:02.106Z",
        heading:
          "What actions lead to progress in potential growth areas / blind spots?",
        points: [
          "Talk to a friend about the things that can deepen your relationship with them",
          "Learn more about establishing a deeper connection with others",
          "Reflect on your past experiences when being able to open up to others benefited you",
          "Cut out unhealthy and toxic relationships that prevent you from maintaining positive relationships",
          "Listen to a podcast about relationships",
        ],

        updatedAt: "2022-07-14T10:22:02.106Z",
        _id: "62cfee4afdcd13520118c581",
      },
    ],
    growthFavorites: [
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
    ],
    percent: 90.17857142857143,
    questionCategory: "Self-acceptance",
    questionCategoryId: "gqinzVK5jnswksY9gz3Jtn12",
  },
  {
    actionFavorites: [
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-09T16:44:17.638Z",
        point:
          "Learn to appreciate less enthusiastic or energetic states, so you become more state independent",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "ACTION",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-09T16:44:17.638Z",
        _id: "63bc4461fec027cb7857280e",
      },
    ],
    description: [
      "This score indicates your current tendency to be warm, sociable, and friendly as opposed to being shy, distant, and unfriendly. It measures how consistently you do actions like appreciating others, hugging or other forms of physical gestures, or making time to have deep conversations with friends and family.",
    ],
    descriptionDetails:
      "<p>What might be potential growth areas / blind spots?</p><ol><li>How to manage your energy well throughout the day?</li><li>How to balance zest with wisdom and prudence?</li><li>How to cultivate tranquil energy and enthusiasm</li><li>How to prevent overexcitement leading to overpromising and underdelivering?</li><li>How to figure out your optimal energy levels for different tasks?</li><li>How to become more grounded, stable, and steady emotionally?</li><li>How to be aware of your own energy levels in order not to deplete yourself too much? (e.g., starting strong is good, but finishing strong is much more important)</li><li>How to avoid expressing too much energy and enthusiasm that might feel inappropriate to others?</li><li>How to make your enthusiasm more grounded and calm?</li><li>How to adjust your energy level when other people are in a less enthusiastic and energetic state?</li><li>How to deal with disappointment if a project you’ve been enthusiastic about didn’t work out and what to learn from this?</li><li>How to avoid draining other people’s energy with your enthusiasm?</li><li>How to combine enthusiasm, strategic thinking, and sound prioritisation?</li><li>How to know when mirroring someone's emotions and states is more appropriate than being energetic and enthusiastic?</li><li>How to combine enthusiasm with seriousness to ensure that your competence is not belittled?</li><li>How to channel enthusiasm in a positive direction by focusing on the most important goals instead of “getting things done”?</li><li>How to better manage impulsive behaviour?</li><li>How to maintain your enthusiasm in times of setbacks and disappointments?</li><li>How to become less reckless with decisions and actions during periods of high enthusiasm?</li><li>How to be more aware of the situations where you might want to tone down your zest and enthusiasm?</li><li>How to know when less enthusiasm is required, and a more neutral attitude is called for? (e.g., in a serious business meeting)</li><li>How to prevent enthusiasm from taking away the necessary focus and discipline?</li></ol><p>What actions lead to progress here?</p><ol><li>Keep a journal to collect situations with other people where your energy and enthusiasm were not well-calibrated to the emotional state of the other person</li><li>Reflect on past situations where (1) you were too enthusiastic about something and (2) this enthusiasm led to negative consequences</li><li>Remind yourself that disappointment (and enthusiasm) is a fleeting feeling</li><li>Learn to appreciate less enthusiastic or energetic states, so you become more state independent</li><li>Observe the energy and enthusiasm of others before speaking or acting to modulate your level</li><li>Analyze the project that you’ve been enthusiastic about but didn’t work out and examine how those experiences can improve your future decision-making</li><li>When you are in a high energy and enthusiasm state, try to add some grounded and calm energy </li><li>Start an energy and enthusiasm log to see if you calibrated them well throughout the day</li><li>Become more aware of the relationship between your enthusiasm, professionalism, and perceived competence</li><li>Create a list of situations where being more neutral and sober would have been more useful</li><li>Specify the level of energy you prefer for different tasks: low, medium, high? Which task works best with which level? Why? </li><li>Make a list of “reckless” decisions from the past that could have been made more prudently if you had toned down your zest and enthusiasm </li><li>Design a system that helps you decide when it is better to be more neutral than very excited about something</li><li>Make it a habit to evaluate your decisions after 3 days if they were based on high levels of energy and enthusiasm </li><li>Reflect on past situations where your enthusiasm has led to overpromising and underdelivering</li><li>Create a list of situations where more neutral and grounded energy is called for (1) at work, (2) when interacting with family members, and (3) when socializing with friends</li><li>List more consequences of an overly enthusiastic attitude: (1) you might not be taken seriously as a competent professional, (2) your expectations might have been set too high for yourself or others, which is draining and demotivating over time, (3) your decisions might have been based on insufficient information leading to poor choices</li><li>Create two categories: one for things that are important but not urgent/immediate/time-sensitive and one for things that are urgent/immediate/time-sensitive. Keep the former in mind when feeling overexcited. For the latter case make sure that they get done in a timely manner without compromising quality </li><li>Consider a “calm energy” training where you focus on cultivating more serenity, stability, and equanimity</li><li>Read more about managing energy like this article: How To Manage Your Energy</li></ol><p><br></p>",
    detailedDescription: [
      "Your moderate score indicates that you might be more often affectionate, pleasant, and hospitable than cold, insincere, and disagreeable. \n\nYou often believe that you can trust your friends, and they know they can trust you too. You experience many warm and trusting relationships with others and sometimes maintain close friendships through the years. Once in a while, you enjoy personal and mutual conversations with family members or friends. \n\nOther people might often feel warm when they interact with you. You might have strong feelings of empathy and affection in your relationships and value the importance of having positive relations with others. You might tend to value and emphasize the achievement of close unions with others and also guide them from time to time.",
    ],
    detailedDescriptionDetails: [
      {
        createdAt: "2022-07-14T10:22:02.106Z",
        heading: "What might be potential growth areas / blind spots?",
        points: [
          "How to have positive relationships with the people around you?",
          "How to develop empathy when listening to other people’s concerns?",
          "How to maintain close relationships with others through the years?",
          "How to take care of yourself while allowing yourself to be a thoughtful person?",
          "How to express your affection in your relationship…d deepen your connection with family and friends?",
        ],
        updatedAt: "2022-07-14T10:22:02.106Z",
        _id: "62cfee4afdcd13520118c580",
      },
      {
        createdAt: "2022-07-14T10:22:02.106Z",
        heading:
          "What actions lead to progress in potential growth areas / blind spots?",
        points: [
          "Talk to a friend about the things that can deepen your relationship with them",
          "Learn more about establishing a deeper connection with others",
          "Reflect on your past experiences when being able to open up to others benefited you",
          "Cut out unhealthy and toxic relationships that prevent you from maintaining positive relationships",
          "Listen to a podcast about relationships",
        ],

        updatedAt: "2022-07-14T10:22:02.106Z",
        _id: "62cfee4afdcd13520118c581",
      },
    ],
    growthFavorites: [
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
    ],
    percent: 90.17857142857143,
    questionCategory: "Self-acceptance",
    questionCategoryId: "gqinzVK5jnswksY9gz3Jtn13",
  },
  {
    actionFavorites: [
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-09T16:44:17.638Z",
        point:
          "Learn to appreciate less enthusiastic or energetic states, so you become more state independent",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "ACTION",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-09T16:44:17.638Z",
        _id: "63bc4461fec027cb7857280e",
      },
    ],
    description: [
      "This score indicates your current tendency to be warm, sociable, and friendly as opposed to being shy, distant, and unfriendly. It measures how consistently you do actions like appreciating others, hugging or other forms of physical gestures, or making time to have deep conversations with friends and family.",
    ],
    descriptionDetails:
      "<p>What might be potential growth areas / blind spots?</p><ol><li>How to manage your energy well throughout the day?</li><li>How to balance zest with wisdom and prudence?</li><li>How to cultivate tranquil energy and enthusiasm</li><li>How to prevent overexcitement leading to overpromising and underdelivering?</li><li>How to figure out your optimal energy levels for different tasks?</li><li>How to become more grounded, stable, and steady emotionally?</li><li>How to be aware of your own energy levels in order not to deplete yourself too much? (e.g., starting strong is good, but finishing strong is much more important)</li><li>How to avoid expressing too much energy and enthusiasm that might feel inappropriate to others?</li><li>How to make your enthusiasm more grounded and calm?</li><li>How to adjust your energy level when other people are in a less enthusiastic and energetic state?</li><li>How to deal with disappointment if a project you’ve been enthusiastic about didn’t work out and what to learn from this?</li><li>How to avoid draining other people’s energy with your enthusiasm?</li><li>How to combine enthusiasm, strategic thinking, and sound prioritisation?</li><li>How to know when mirroring someone's emotions and states is more appropriate than being energetic and enthusiastic?</li><li>How to combine enthusiasm with seriousness to ensure that your competence is not belittled?</li><li>How to channel enthusiasm in a positive direction by focusing on the most important goals instead of “getting things done”?</li><li>How to better manage impulsive behaviour?</li><li>How to maintain your enthusiasm in times of setbacks and disappointments?</li><li>How to become less reckless with decisions and actions during periods of high enthusiasm?</li><li>How to be more aware of the situations where you might want to tone down your zest and enthusiasm?</li><li>How to know when less enthusiasm is required, and a more neutral attitude is called for? (e.g., in a serious business meeting)</li><li>How to prevent enthusiasm from taking away the necessary focus and discipline?</li></ol><p>What actions lead to progress here?</p><ol><li>Keep a journal to collect situations with other people where your energy and enthusiasm were not well-calibrated to the emotional state of the other person</li><li>Reflect on past situations where (1) you were too enthusiastic about something and (2) this enthusiasm led to negative consequences</li><li>Remind yourself that disappointment (and enthusiasm) is a fleeting feeling</li><li>Learn to appreciate less enthusiastic or energetic states, so you become more state independent</li><li>Observe the energy and enthusiasm of others before speaking or acting to modulate your level</li><li>Analyze the project that you’ve been enthusiastic about but didn’t work out and examine how those experiences can improve your future decision-making</li><li>When you are in a high energy and enthusiasm state, try to add some grounded and calm energy </li><li>Start an energy and enthusiasm log to see if you calibrated them well throughout the day</li><li>Become more aware of the relationship between your enthusiasm, professionalism, and perceived competence</li><li>Create a list of situations where being more neutral and sober would have been more useful</li><li>Specify the level of energy you prefer for different tasks: low, medium, high? Which task works best with which level? Why? </li><li>Make a list of “reckless” decisions from the past that could have been made more prudently if you had toned down your zest and enthusiasm </li><li>Design a system that helps you decide when it is better to be more neutral than very excited about something</li><li>Make it a habit to evaluate your decisions after 3 days if they were based on high levels of energy and enthusiasm </li><li>Reflect on past situations where your enthusiasm has led to overpromising and underdelivering</li><li>Create a list of situations where more neutral and grounded energy is called for (1) at work, (2) when interacting with family members, and (3) when socializing with friends</li><li>List more consequences of an overly enthusiastic attitude: (1) you might not be taken seriously as a competent professional, (2) your expectations might have been set too high for yourself or others, which is draining and demotivating over time, (3) your decisions might have been based on insufficient information leading to poor choices</li><li>Create two categories: one for things that are important but not urgent/immediate/time-sensitive and one for things that are urgent/immediate/time-sensitive. Keep the former in mind when feeling overexcited. For the latter case make sure that they get done in a timely manner without compromising quality </li><li>Consider a “calm energy” training where you focus on cultivating more serenity, stability, and equanimity</li><li>Read more about managing energy like this article: How To Manage Your Energy</li></ol><p><br></p>",
    detailedDescription: [
      "Your moderate score indicates that you might be more often affectionate, pleasant, and hospitable than cold, insincere, and disagreeable. \n\nYou often believe that you can trust your friends, and they know they can trust you too. You experience many warm and trusting relationships with others and sometimes maintain close friendships through the years. Once in a while, you enjoy personal and mutual conversations with family members or friends. \n\nOther people might often feel warm when they interact with you. You might have strong feelings of empathy and affection in your relationships and value the importance of having positive relations with others. You might tend to value and emphasize the achievement of close unions with others and also guide them from time to time.",
    ],
    detailedDescriptionDetails: [
      {
        createdAt: "2022-07-14T10:22:02.106Z",
        heading: "What might be potential growth areas / blind spots?",
        points: [
          "How to have positive relationships with the people around you?",
          "How to develop empathy when listening to other people’s concerns?",
          "How to maintain close relationships with others through the years?",
          "How to take care of yourself while allowing yourself to be a thoughtful person?",
          "How to express your affection in your relationship…d deepen your connection with family and friends?",
        ],
        updatedAt: "2022-07-14T10:22:02.106Z",
        _id: "62cfee4afdcd13520118c580",
      },
      {
        createdAt: "2022-07-14T10:22:02.106Z",
        heading:
          "What actions lead to progress in potential growth areas / blind spots?",
        points: [
          "Talk to a friend about the things that can deepen your relationship with them",
          "Learn more about establishing a deeper connection with others",
          "Reflect on your past experiences when being able to open up to others benefited you",
          "Cut out unhealthy and toxic relationships that prevent you from maintaining positive relationships",
          "Listen to a podcast about relationships",
        ],

        updatedAt: "2022-07-14T10:22:02.106Z",
        _id: "62cfee4afdcd13520118c581",
      },
    ],
    growthFavorites: [
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
    ],
    percent: 90.17857142857143,
    questionCategory: "Self-acceptance",
    questionCategoryId: "gqinzVK5jnswksY9gz3Jtn14",
  },
  {
    actionFavorites: [
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-09T16:44:17.638Z",
        point:
          "Learn to appreciate less enthusiastic or energetic states, so you become more state independent",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "ACTION",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-09T16:44:17.638Z",
        _id: "63bc4461fec027cb7857280e",
      },
    ],
    description: [
      "This score indicates your current tendency to be warm, sociable, and friendly as opposed to being shy, distant, and unfriendly. It measures how consistently you do actions like appreciating others, hugging or other forms of physical gestures, or making time to have deep conversations with friends and family.",
    ],
    descriptionDetails:
      "<p>What might be potential growth areas / blind spots?</p><ol><li>How to manage your energy well throughout the day?</li><li>How to balance zest with wisdom and prudence?</li><li>How to cultivate tranquil energy and enthusiasm</li><li>How to prevent overexcitement leading to overpromising and underdelivering?</li><li>How to figure out your optimal energy levels for different tasks?</li><li>How to become more grounded, stable, and steady emotionally?</li><li>How to be aware of your own energy levels in order not to deplete yourself too much? (e.g., starting strong is good, but finishing strong is much more important)</li><li>How to avoid expressing too much energy and enthusiasm that might feel inappropriate to others?</li><li>How to make your enthusiasm more grounded and calm?</li><li>How to adjust your energy level when other people are in a less enthusiastic and energetic state?</li><li>How to deal with disappointment if a project you’ve been enthusiastic about didn’t work out and what to learn from this?</li><li>How to avoid draining other people’s energy with your enthusiasm?</li><li>How to combine enthusiasm, strategic thinking, and sound prioritisation?</li><li>How to know when mirroring someone's emotions and states is more appropriate than being energetic and enthusiastic?</li><li>How to combine enthusiasm with seriousness to ensure that your competence is not belittled?</li><li>How to channel enthusiasm in a positive direction by focusing on the most important goals instead of “getting things done”?</li><li>How to better manage impulsive behaviour?</li><li>How to maintain your enthusiasm in times of setbacks and disappointments?</li><li>How to become less reckless with decisions and actions during periods of high enthusiasm?</li><li>How to be more aware of the situations where you might want to tone down your zest and enthusiasm?</li><li>How to know when less enthusiasm is required, and a more neutral attitude is called for? (e.g., in a serious business meeting)</li><li>How to prevent enthusiasm from taking away the necessary focus and discipline?</li></ol><p>What actions lead to progress here?</p><ol><li>Keep a journal to collect situations with other people where your energy and enthusiasm were not well-calibrated to the emotional state of the other person</li><li>Reflect on past situations where (1) you were too enthusiastic about something and (2) this enthusiasm led to negative consequences</li><li>Remind yourself that disappointment (and enthusiasm) is a fleeting feeling</li><li>Learn to appreciate less enthusiastic or energetic states, so you become more state independent</li><li>Observe the energy and enthusiasm of others before speaking or acting to modulate your level</li><li>Analyze the project that you’ve been enthusiastic about but didn’t work out and examine how those experiences can improve your future decision-making</li><li>When you are in a high energy and enthusiasm state, try to add some grounded and calm energy </li><li>Start an energy and enthusiasm log to see if you calibrated them well throughout the day</li><li>Become more aware of the relationship between your enthusiasm, professionalism, and perceived competence</li><li>Create a list of situations where being more neutral and sober would have been more useful</li><li>Specify the level of energy you prefer for different tasks: low, medium, high? Which task works best with which level? Why? </li><li>Make a list of “reckless” decisions from the past that could have been made more prudently if you had toned down your zest and enthusiasm </li><li>Design a system that helps you decide when it is better to be more neutral than very excited about something</li><li>Make it a habit to evaluate your decisions after 3 days if they were based on high levels of energy and enthusiasm </li><li>Reflect on past situations where your enthusiasm has led to overpromising and underdelivering</li><li>Create a list of situations where more neutral and grounded energy is called for (1) at work, (2) when interacting with family members, and (3) when socializing with friends</li><li>List more consequences of an overly enthusiastic attitude: (1) you might not be taken seriously as a competent professional, (2) your expectations might have been set too high for yourself or others, which is draining and demotivating over time, (3) your decisions might have been based on insufficient information leading to poor choices</li><li>Create two categories: one for things that are important but not urgent/immediate/time-sensitive and one for things that are urgent/immediate/time-sensitive. Keep the former in mind when feeling overexcited. For the latter case make sure that they get done in a timely manner without compromising quality </li><li>Consider a “calm energy” training where you focus on cultivating more serenity, stability, and equanimity</li><li>Read more about managing energy like this article: How To Manage Your Energy</li></ol><p><br></p>",
    detailedDescription: [
      "Your moderate score indicates that you might be more often affectionate, pleasant, and hospitable than cold, insincere, and disagreeable. \n\nYou often believe that you can trust your friends, and they know they can trust you too. You experience many warm and trusting relationships with others and sometimes maintain close friendships through the years. Once in a while, you enjoy personal and mutual conversations with family members or friends. \n\nOther people might often feel warm when they interact with you. You might have strong feelings of empathy and affection in your relationships and value the importance of having positive relations with others. You might tend to value and emphasize the achievement of close unions with others and also guide them from time to time.",
    ],
    detailedDescriptionDetails: [
      {
        createdAt: "2022-07-14T10:22:02.106Z",
        heading: "What might be potential growth areas / blind spots?",
        points: [
          "How to have positive relationships with the people around you?",
          "How to develop empathy when listening to other people’s concerns?",
          "How to maintain close relationships with others through the years?",
          "How to take care of yourself while allowing yourself to be a thoughtful person?",
          "How to express your affection in your relationship…d deepen your connection with family and friends?",
        ],
        updatedAt: "2022-07-14T10:22:02.106Z",
        _id: "62cfee4afdcd13520118c580",
      },
      {
        createdAt: "2022-07-14T10:22:02.106Z",
        heading:
          "What actions lead to progress in potential growth areas / blind spots?",
        points: [
          "Talk to a friend about the things that can deepen your relationship with them",
          "Learn more about establishing a deeper connection with others",
          "Reflect on your past experiences when being able to open up to others benefited you",
          "Cut out unhealthy and toxic relationships that prevent you from maintaining positive relationships",
          "Listen to a podcast about relationships",
        ],

        updatedAt: "2022-07-14T10:22:02.106Z",
        _id: "62cfee4afdcd13520118c581",
      },
    ],
    growthFavorites: [
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
    ],
    percent: 90.17857142857143,
    questionCategory: "Self-acceptance",
    questionCategoryId: "gqinzVK5jnswksY9gz3Jtn15",
  },
  {
    actionFavorites: [
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-09T16:44:17.638Z",
        point:
          "Learn to appreciate less enthusiastic or energetic states, so you become more state independent",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "ACTION",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-09T16:44:17.638Z",
        _id: "63bc4461fec027cb7857280e",
      },
    ],
    description: [
      "This score indicates your current tendency to be warm, sociable, and friendly as opposed to being shy, distant, and unfriendly. It measures how consistently you do actions like appreciating others, hugging or other forms of physical gestures, or making time to have deep conversations with friends and family.",
    ],
    descriptionDetails:
      "<p>What might be potential growth areas / blind spots?</p><ol><li>How to manage your energy well throughout the day?</li><li>How to balance zest with wisdom and prudence?</li><li>How to cultivate tranquil energy and enthusiasm</li><li>How to prevent overexcitement leading to overpromising and underdelivering?</li><li>How to figure out your optimal energy levels for different tasks?</li><li>How to become more grounded, stable, and steady emotionally?</li><li>How to be aware of your own energy levels in order not to deplete yourself too much? (e.g., starting strong is good, but finishing strong is much more important)</li><li>How to avoid expressing too much energy and enthusiasm that might feel inappropriate to others?</li><li>How to make your enthusiasm more grounded and calm?</li><li>How to adjust your energy level when other people are in a less enthusiastic and energetic state?</li><li>How to deal with disappointment if a project you’ve been enthusiastic about didn’t work out and what to learn from this?</li><li>How to avoid draining other people’s energy with your enthusiasm?</li><li>How to combine enthusiasm, strategic thinking, and sound prioritisation?</li><li>How to know when mirroring someone's emotions and states is more appropriate than being energetic and enthusiastic?</li><li>How to combine enthusiasm with seriousness to ensure that your competence is not belittled?</li><li>How to channel enthusiasm in a positive direction by focusing on the most important goals instead of “getting things done”?</li><li>How to better manage impulsive behaviour?</li><li>How to maintain your enthusiasm in times of setbacks and disappointments?</li><li>How to become less reckless with decisions and actions during periods of high enthusiasm?</li><li>How to be more aware of the situations where you might want to tone down your zest and enthusiasm?</li><li>How to know when less enthusiasm is required, and a more neutral attitude is called for? (e.g., in a serious business meeting)</li><li>How to prevent enthusiasm from taking away the necessary focus and discipline?</li></ol><p>What actions lead to progress here?</p><ol><li>Keep a journal to collect situations with other people where your energy and enthusiasm were not well-calibrated to the emotional state of the other person</li><li>Reflect on past situations where (1) you were too enthusiastic about something and (2) this enthusiasm led to negative consequences</li><li>Remind yourself that disappointment (and enthusiasm) is a fleeting feeling</li><li>Learn to appreciate less enthusiastic or energetic states, so you become more state independent</li><li>Observe the energy and enthusiasm of others before speaking or acting to modulate your level</li><li>Analyze the project that you’ve been enthusiastic about but didn’t work out and examine how those experiences can improve your future decision-making</li><li>When you are in a high energy and enthusiasm state, try to add some grounded and calm energy </li><li>Start an energy and enthusiasm log to see if you calibrated them well throughout the day</li><li>Become more aware of the relationship between your enthusiasm, professionalism, and perceived competence</li><li>Create a list of situations where being more neutral and sober would have been more useful</li><li>Specify the level of energy you prefer for different tasks: low, medium, high? Which task works best with which level? Why? </li><li>Make a list of “reckless” decisions from the past that could have been made more prudently if you had toned down your zest and enthusiasm </li><li>Design a system that helps you decide when it is better to be more neutral than very excited about something</li><li>Make it a habit to evaluate your decisions after 3 days if they were based on high levels of energy and enthusiasm </li><li>Reflect on past situations where your enthusiasm has led to overpromising and underdelivering</li><li>Create a list of situations where more neutral and grounded energy is called for (1) at work, (2) when interacting with family members, and (3) when socializing with friends</li><li>List more consequences of an overly enthusiastic attitude: (1) you might not be taken seriously as a competent professional, (2) your expectations might have been set too high for yourself or others, which is draining and demotivating over time, (3) your decisions might have been based on insufficient information leading to poor choices</li><li>Create two categories: one for things that are important but not urgent/immediate/time-sensitive and one for things that are urgent/immediate/time-sensitive. Keep the former in mind when feeling overexcited. For the latter case make sure that they get done in a timely manner without compromising quality </li><li>Consider a “calm energy” training where you focus on cultivating more serenity, stability, and equanimity</li><li>Read more about managing energy like this article: How To Manage Your Energy</li></ol><p><br></p>",
    detailedDescription: [
      "Your moderate score indicates that you might be more often affectionate, pleasant, and hospitable than cold, insincere, and disagreeable. \n\nYou often believe that you can trust your friends, and they know they can trust you too. You experience many warm and trusting relationships with others and sometimes maintain close friendships through the years. Once in a while, you enjoy personal and mutual conversations with family members or friends. \n\nOther people might often feel warm when they interact with you. You might have strong feelings of empathy and affection in your relationships and value the importance of having positive relations with others. You might tend to value and emphasize the achievement of close unions with others and also guide them from time to time.",
    ],
    detailedDescriptionDetails: [
      {
        createdAt: "2022-07-14T10:22:02.106Z",
        heading: "What might be potential growth areas / blind spots?",
        points: [
          "How to have positive relationships with the people around you?",
          "How to develop empathy when listening to other people’s concerns?",
          "How to maintain close relationships with others through the years?",
          "How to take care of yourself while allowing yourself to be a thoughtful person?",
          "How to express your affection in your relationship…d deepen your connection with family and friends?",
        ],
        updatedAt: "2022-07-14T10:22:02.106Z",
        _id: "62cfee4afdcd13520118c580",
      },
      {
        createdAt: "2022-07-14T10:22:02.106Z",
        heading:
          "What actions lead to progress in potential growth areas / blind spots?",
        points: [
          "Talk to a friend about the things that can deepen your relationship with them",
          "Learn more about establishing a deeper connection with others",
          "Reflect on your past experiences when being able to open up to others benefited you",
          "Cut out unhealthy and toxic relationships that prevent you from maintaining positive relationships",
          "Listen to a podcast about relationships",
        ],

        updatedAt: "2022-07-14T10:22:02.106Z",
        _id: "62cfee4afdcd13520118c581",
      },
    ],
    growthFavorites: [
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
      {
        category: "Well-being",
        category_id: "fdqaqggF1pDWmnjURNvg1d",
        createdAt: "2023-01-04T10:04:20.207Z",
        point:
          "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
        questionCategory: "Positive Relations",
        questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
        subCategory: "Psychological well-being",
        subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
        type: "GROWTH",
        uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
        updatedAt: "2023-01-04T10:04:20.207Z",
        __v: 0,
        _id: "63b54f24bb36c7c4fa2313b3",
      },
    ],
    percent: 90.17857142857143,
    questionCategory: "Self-acceptance",
    questionCategoryId: "gqinzVK5jnswksY9gz3Jtn17",
  },
];
 
export const fatuDiamension = [
    {
      actionFavorites: [
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-09T16:44:17.638Z",
          point:
            "Learn to appreciate less enthusiastic or energetic states, so you become more state independent",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "ACTION",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-09T16:44:17.638Z",
          _id: "63bc4461fec027cb7857280e",
        },
      ],
      description: [
        "This score indicates your current tendency to be warm, sociable, and friendly as opposed to being shy, distant, and unfriendly. It measures how consistently you do actions like appreciating others, hugging or other forms of physical gestures, or making time to have deep conversations with friends and family.",
      ],
      descriptionDetails:
        "<p>What might be potential growth areas / blind spots?</p><ol><li>How to manage your energy well throughout the day?</li><li>How to balance zest with wisdom and prudence?</li><li>How to cultivate tranquil energy and enthusiasm</li><li>How to prevent overexcitement leading to overpromising and underdelivering?</li><li>How to figure out your optimal energy levels for different tasks?</li><li>How to become more grounded, stable, and steady emotionally?</li><li>How to be aware of your own energy levels in order not to deplete yourself too much? (e.g., starting strong is good, but finishing strong is much more important)</li><li>How to avoid expressing too much energy and enthusiasm that might feel inappropriate to others?</li><li>How to make your enthusiasm more grounded and calm?</li><li>How to adjust your energy level when other people are in a less enthusiastic and energetic state?</li><li>How to deal with disappointment if a project you’ve been enthusiastic about didn’t work out and what to learn from this?</li><li>How to avoid draining other people’s energy with your enthusiasm?</li><li>How to combine enthusiasm, strategic thinking, and sound prioritisation?</li><li>How to know when mirroring someone's emotions and states is more appropriate than being energetic and enthusiastic?</li><li>How to combine enthusiasm with seriousness to ensure that your competence is not belittled?</li><li>How to channel enthusiasm in a positive direction by focusing on the most important goals instead of “getting things done”?</li><li>How to better manage impulsive behaviour?</li><li>How to maintain your enthusiasm in times of setbacks and disappointments?</li><li>How to become less reckless with decisions and actions during periods of high enthusiasm?</li><li>How to be more aware of the situations where you might want to tone down your zest and enthusiasm?</li><li>How to know when less enthusiasm is required, and a more neutral attitude is called for? (e.g., in a serious business meeting)</li><li>How to prevent enthusiasm from taking away the necessary focus and discipline?</li></ol><p>What actions lead to progress here?</p><ol><li>Keep a journal to collect situations with other people where your energy and enthusiasm were not well-calibrated to the emotional state of the other person</li><li>Reflect on past situations where (1) you were too enthusiastic about something and (2) this enthusiasm led to negative consequences</li><li>Remind yourself that disappointment (and enthusiasm) is a fleeting feeling</li><li>Learn to appreciate less enthusiastic or energetic states, so you become more state independent</li><li>Observe the energy and enthusiasm of others before speaking or acting to modulate your level</li><li>Analyze the project that you’ve been enthusiastic about but didn’t work out and examine how those experiences can improve your future decision-making</li><li>When you are in a high energy and enthusiasm state, try to add some grounded and calm energy </li><li>Start an energy and enthusiasm log to see if you calibrated them well throughout the day</li><li>Become more aware of the relationship between your enthusiasm, professionalism, and perceived competence</li><li>Create a list of situations where being more neutral and sober would have been more useful</li><li>Specify the level of energy you prefer for different tasks: low, medium, high? Which task works best with which level? Why? </li><li>Make a list of “reckless” decisions from the past that could have been made more prudently if you had toned down your zest and enthusiasm </li><li>Design a system that helps you decide when it is better to be more neutral than very excited about something</li><li>Make it a habit to evaluate your decisions after 3 days if they were based on high levels of energy and enthusiasm </li><li>Reflect on past situations where your enthusiasm has led to overpromising and underdelivering</li><li>Create a list of situations where more neutral and grounded energy is called for (1) at work, (2) when interacting with family members, and (3) when socializing with friends</li><li>List more consequences of an overly enthusiastic attitude: (1) you might not be taken seriously as a competent professional, (2) your expectations might have been set too high for yourself or others, which is draining and demotivating over time, (3) your decisions might have been based on insufficient information leading to poor choices</li><li>Create two categories: one for things that are important but not urgent/immediate/time-sensitive and one for things that are urgent/immediate/time-sensitive. Keep the former in mind when feeling overexcited. For the latter case make sure that they get done in a timely manner without compromising quality </li><li>Consider a “calm energy” training where you focus on cultivating more serenity, stability, and equanimity</li><li>Read more about managing energy like this article: How To Manage Your Energy</li></ol><p><br></p>",
      detailedDescription: [
        "Your moderate score indicates that you might be more often affectionate, pleasant, and hospitable than cold, insincere, and disagreeable. \n\nYou often believe that you can trust your friends, and they know they can trust you too. You experience many warm and trusting relationships with others and sometimes maintain close friendships through the years. Once in a while, you enjoy personal and mutual conversations with family members or friends. \n\nOther people might often feel warm when they interact with you. You might have strong feelings of empathy and affection in your relationships and value the importance of having positive relations with others. You might tend to value and emphasize the achievement of close unions with others and also guide them from time to time.",
      ],
      detailedDescriptionDetails: [
        {
          createdAt: "2022-07-14T10:22:02.106Z",
          heading: "What might be potential growth areas / blind spots?",
          points: [
            "How to have positive relationships with the people around you?",
            "How to develop empathy when listening to other people’s concerns?",
            "How to maintain close relationships with others through the years?",
            "How to take care of yourself while allowing yourself to be a thoughtful person?",
            "How to express your affection in your relationship…d deepen your connection with family and friends?",
          ],
          updatedAt: "2022-07-14T10:22:02.106Z",
          _id: "62cfee4afdcd13520118c580",
        },
        {
          createdAt: "2022-07-14T10:22:02.106Z",
          heading:
            "What actions lead to progress in potential growth areas / blind spots?",
          points: [
            "Talk to a friend about the things that can deepen your relationship with them",
            "Learn more about establishing a deeper connection with others",
            "Reflect on your past experiences when being able to open up to others benefited you",
            "Cut out unhealthy and toxic relationships that prevent you from maintaining positive relationships",
            "Listen to a podcast about relationships",
          ],
  
          updatedAt: "2022-07-14T10:22:02.106Z",
          _id: "62cfee4afdcd13520118c581",
        },
      ],
      growthFavorites: [
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
      ],
      percent: 90.17857142857143,
      questionCategory: "Self-acceptance",
      questionCategoryId: "gqinzVK5jnswksY9gz3Jtn22",
    },
    {
      actionFavorites: [
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-09T16:44:17.638Z",
          point:
            "Learn to appreciate less enthusiastic or energetic states, so you become more state independent",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "ACTION",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-09T16:44:17.638Z",
          _id: "63bc4461fec027cb7857280e",
        },
      ],
      description: [
        "This score indicates your current tendency to be warm, sociable, and friendly as opposed to being shy, distant, and unfriendly. It measures how consistently you do actions like appreciating others, hugging or other forms of physical gestures, or making time to have deep conversations with friends and family.",
      ],
      descriptionDetails:
        "<p>What might be potential growth areas / blind spots?</p><ol><li>How to manage your energy well throughout the day?</li><li>How to balance zest with wisdom and prudence?</li><li>How to cultivate tranquil energy and enthusiasm</li><li>How to prevent overexcitement leading to overpromising and underdelivering?</li><li>How to figure out your optimal energy levels for different tasks?</li><li>How to become more grounded, stable, and steady emotionally?</li><li>How to be aware of your own energy levels in order not to deplete yourself too much? (e.g., starting strong is good, but finishing strong is much more important)</li><li>How to avoid expressing too much energy and enthusiasm that might feel inappropriate to others?</li><li>How to make your enthusiasm more grounded and calm?</li><li>How to adjust your energy level when other people are in a less enthusiastic and energetic state?</li><li>How to deal with disappointment if a project you’ve been enthusiastic about didn’t work out and what to learn from this?</li><li>How to avoid draining other people’s energy with your enthusiasm?</li><li>How to combine enthusiasm, strategic thinking, and sound prioritisation?</li><li>How to know when mirroring someone's emotions and states is more appropriate than being energetic and enthusiastic?</li><li>How to combine enthusiasm with seriousness to ensure that your competence is not belittled?</li><li>How to channel enthusiasm in a positive direction by focusing on the most important goals instead of “getting things done”?</li><li>How to better manage impulsive behaviour?</li><li>How to maintain your enthusiasm in times of setbacks and disappointments?</li><li>How to become less reckless with decisions and actions during periods of high enthusiasm?</li><li>How to be more aware of the situations where you might want to tone down your zest and enthusiasm?</li><li>How to know when less enthusiasm is required, and a more neutral attitude is called for? (e.g., in a serious business meeting)</li><li>How to prevent enthusiasm from taking away the necessary focus and discipline?</li></ol><p>What actions lead to progress here?</p><ol><li>Keep a journal to collect situations with other people where your energy and enthusiasm were not well-calibrated to the emotional state of the other person</li><li>Reflect on past situations where (1) you were too enthusiastic about something and (2) this enthusiasm led to negative consequences</li><li>Remind yourself that disappointment (and enthusiasm) is a fleeting feeling</li><li>Learn to appreciate less enthusiastic or energetic states, so you become more state independent</li><li>Observe the energy and enthusiasm of others before speaking or acting to modulate your level</li><li>Analyze the project that you’ve been enthusiastic about but didn’t work out and examine how those experiences can improve your future decision-making</li><li>When you are in a high energy and enthusiasm state, try to add some grounded and calm energy </li><li>Start an energy and enthusiasm log to see if you calibrated them well throughout the day</li><li>Become more aware of the relationship between your enthusiasm, professionalism, and perceived competence</li><li>Create a list of situations where being more neutral and sober would have been more useful</li><li>Specify the level of energy you prefer for different tasks: low, medium, high? Which task works best with which level? Why? </li><li>Make a list of “reckless” decisions from the past that could have been made more prudently if you had toned down your zest and enthusiasm </li><li>Design a system that helps you decide when it is better to be more neutral than very excited about something</li><li>Make it a habit to evaluate your decisions after 3 days if they were based on high levels of energy and enthusiasm </li><li>Reflect on past situations where your enthusiasm has led to overpromising and underdelivering</li><li>Create a list of situations where more neutral and grounded energy is called for (1) at work, (2) when interacting with family members, and (3) when socializing with friends</li><li>List more consequences of an overly enthusiastic attitude: (1) you might not be taken seriously as a competent professional, (2) your expectations might have been set too high for yourself or others, which is draining and demotivating over time, (3) your decisions might have been based on insufficient information leading to poor choices</li><li>Create two categories: one for things that are important but not urgent/immediate/time-sensitive and one for things that are urgent/immediate/time-sensitive. Keep the former in mind when feeling overexcited. For the latter case make sure that they get done in a timely manner without compromising quality </li><li>Consider a “calm energy” training where you focus on cultivating more serenity, stability, and equanimity</li><li>Read more about managing energy like this article: How To Manage Your Energy</li></ol><p><br></p>",
      detailedDescription: [
        "Your moderate score indicates that you might be more often affectionate, pleasant, and hospitable than cold, insincere, and disagreeable. \n\nYou often believe that you can trust your friends, and they know they can trust you too. You experience many warm and trusting relationships with others and sometimes maintain close friendships through the years. Once in a while, you enjoy personal and mutual conversations with family members or friends. \n\nOther people might often feel warm when they interact with you. You might have strong feelings of empathy and affection in your relationships and value the importance of having positive relations with others. You might tend to value and emphasize the achievement of close unions with others and also guide them from time to time.",
      ],
      detailedDescriptionDetails: [
        {
          createdAt: "2022-07-14T10:22:02.106Z",
          heading: "What might be potential growth areas / blind spots?",
          points: [
            "How to have positive relationships with the people around you?",
            "How to develop empathy when listening to other people’s concerns?",
            "How to maintain close relationships with others through the years?",
            "How to take care of yourself while allowing yourself to be a thoughtful person?",
            "How to express your affection in your relationship…d deepen your connection with family and friends?",
          ],
          updatedAt: "2022-07-14T10:22:02.106Z",
          _id: "62cfee4afdcd13520118c580",
        },
        {
          createdAt: "2022-07-14T10:22:02.106Z",
          heading:
            "What actions lead to progress in potential growth areas / blind spots?",
          points: [
            "Talk to a friend about the things that can deepen your relationship with them",
            "Learn more about establishing a deeper connection with others",
            "Reflect on your past experiences when being able to open up to others benefited you",
            "Cut out unhealthy and toxic relationships that prevent you from maintaining positive relationships",
            "Listen to a podcast about relationships",
          ],
  
          updatedAt: "2022-07-14T10:22:02.106Z",
          _id: "62cfee4afdcd13520118c581",
        },
      ],
      growthFavorites: [
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
      ],
      percent: 90.17857142857143,
      questionCategory: "Self-acceptance",
      questionCategoryId: "gqinzVK5jnswksY9gz3Jtn23",
    },
    {
      actionFavorites: [
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-09T16:44:17.638Z",
          point:
            "Learn to appreciate less enthusiastic or energetic states, so you become more state independent",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "ACTION",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-09T16:44:17.638Z",
          _id: "63bc4461fec027cb7857280e",
        },
      ],
      description: [
        "This score indicates your current tendency to be warm, sociable, and friendly as opposed to being shy, distant, and unfriendly. It measures how consistently you do actions like appreciating others, hugging or other forms of physical gestures, or making time to have deep conversations with friends and family.",
      ],
      descriptionDetails:
        "<p>What might be potential growth areas / blind spots?</p><ol><li>How to manage your energy well throughout the day?</li><li>How to balance zest with wisdom and prudence?</li><li>How to cultivate tranquil energy and enthusiasm</li><li>How to prevent overexcitement leading to overpromising and underdelivering?</li><li>How to figure out your optimal energy levels for different tasks?</li><li>How to become more grounded, stable, and steady emotionally?</li><li>How to be aware of your own energy levels in order not to deplete yourself too much? (e.g., starting strong is good, but finishing strong is much more important)</li><li>How to avoid expressing too much energy and enthusiasm that might feel inappropriate to others?</li><li>How to make your enthusiasm more grounded and calm?</li><li>How to adjust your energy level when other people are in a less enthusiastic and energetic state?</li><li>How to deal with disappointment if a project you’ve been enthusiastic about didn’t work out and what to learn from this?</li><li>How to avoid draining other people’s energy with your enthusiasm?</li><li>How to combine enthusiasm, strategic thinking, and sound prioritisation?</li><li>How to know when mirroring someone's emotions and states is more appropriate than being energetic and enthusiastic?</li><li>How to combine enthusiasm with seriousness to ensure that your competence is not belittled?</li><li>How to channel enthusiasm in a positive direction by focusing on the most important goals instead of “getting things done”?</li><li>How to better manage impulsive behaviour?</li><li>How to maintain your enthusiasm in times of setbacks and disappointments?</li><li>How to become less reckless with decisions and actions during periods of high enthusiasm?</li><li>How to be more aware of the situations where you might want to tone down your zest and enthusiasm?</li><li>How to know when less enthusiasm is required, and a more neutral attitude is called for? (e.g., in a serious business meeting)</li><li>How to prevent enthusiasm from taking away the necessary focus and discipline?</li></ol><p>What actions lead to progress here?</p><ol><li>Keep a journal to collect situations with other people where your energy and enthusiasm were not well-calibrated to the emotional state of the other person</li><li>Reflect on past situations where (1) you were too enthusiastic about something and (2) this enthusiasm led to negative consequences</li><li>Remind yourself that disappointment (and enthusiasm) is a fleeting feeling</li><li>Learn to appreciate less enthusiastic or energetic states, so you become more state independent</li><li>Observe the energy and enthusiasm of others before speaking or acting to modulate your level</li><li>Analyze the project that you’ve been enthusiastic about but didn’t work out and examine how those experiences can improve your future decision-making</li><li>When you are in a high energy and enthusiasm state, try to add some grounded and calm energy </li><li>Start an energy and enthusiasm log to see if you calibrated them well throughout the day</li><li>Become more aware of the relationship between your enthusiasm, professionalism, and perceived competence</li><li>Create a list of situations where being more neutral and sober would have been more useful</li><li>Specify the level of energy you prefer for different tasks: low, medium, high? Which task works best with which level? Why? </li><li>Make a list of “reckless” decisions from the past that could have been made more prudently if you had toned down your zest and enthusiasm </li><li>Design a system that helps you decide when it is better to be more neutral than very excited about something</li><li>Make it a habit to evaluate your decisions after 3 days if they were based on high levels of energy and enthusiasm </li><li>Reflect on past situations where your enthusiasm has led to overpromising and underdelivering</li><li>Create a list of situations where more neutral and grounded energy is called for (1) at work, (2) when interacting with family members, and (3) when socializing with friends</li><li>List more consequences of an overly enthusiastic attitude: (1) you might not be taken seriously as a competent professional, (2) your expectations might have been set too high for yourself or others, which is draining and demotivating over time, (3) your decisions might have been based on insufficient information leading to poor choices</li><li>Create two categories: one for things that are important but not urgent/immediate/time-sensitive and one for things that are urgent/immediate/time-sensitive. Keep the former in mind when feeling overexcited. For the latter case make sure that they get done in a timely manner without compromising quality </li><li>Consider a “calm energy” training where you focus on cultivating more serenity, stability, and equanimity</li><li>Read more about managing energy like this article: How To Manage Your Energy</li></ol><p><br></p>",
      detailedDescription: [
        "Your moderate score indicates that you might be more often affectionate, pleasant, and hospitable than cold, insincere, and disagreeable. \n\nYou often believe that you can trust your friends, and they know they can trust you too. You experience many warm and trusting relationships with others and sometimes maintain close friendships through the years. Once in a while, you enjoy personal and mutual conversations with family members or friends. \n\nOther people might often feel warm when they interact with you. You might have strong feelings of empathy and affection in your relationships and value the importance of having positive relations with others. You might tend to value and emphasize the achievement of close unions with others and also guide them from time to time.",
      ],
      detailedDescriptionDetails: [
        {
          createdAt: "2022-07-14T10:22:02.106Z",
          heading: "What might be potential growth areas / blind spots?",
          points: [
            "How to have positive relationships with the people around you?",
            "How to develop empathy when listening to other people’s concerns?",
            "How to maintain close relationships with others through the years?",
            "How to take care of yourself while allowing yourself to be a thoughtful person?",
            "How to express your affection in your relationship…d deepen your connection with family and friends?",
          ],
          updatedAt: "2022-07-14T10:22:02.106Z",
          _id: "62cfee4afdcd13520118c580",
        },
        {
          createdAt: "2022-07-14T10:22:02.106Z",
          heading:
            "What actions lead to progress in potential growth areas / blind spots?",
          points: [
            "Talk to a friend about the things that can deepen your relationship with them",
            "Learn more about establishing a deeper connection with others",
            "Reflect on your past experiences when being able to open up to others benefited you",
            "Cut out unhealthy and toxic relationships that prevent you from maintaining positive relationships",
            "Listen to a podcast about relationships",
          ],
  
          updatedAt: "2022-07-14T10:22:02.106Z",
          _id: "62cfee4afdcd13520118c581",
        },
      ],
      growthFavorites: [
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
      ],
      percent: 90.17857142857143,
      questionCategory: "Self-acceptance",
      questionCategoryId: "gqinzVK5jnswksY9gz3Jtn24",
    },
    {
      actionFavorites: [
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-09T16:44:17.638Z",
          point:
            "Learn to appreciate less enthusiastic or energetic states, so you become more state independent",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "ACTION",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-09T16:44:17.638Z",
          _id: "63bc4461fec027cb7857280e",
        },
      ],
      description: [
        "This score indicates your current tendency to be warm, sociable, and friendly as opposed to being shy, distant, and unfriendly. It measures how consistently you do actions like appreciating others, hugging or other forms of physical gestures, or making time to have deep conversations with friends and family.",
      ],
      descriptionDetails:
        "<p>What might be potential growth areas / blind spots?</p><ol><li>How to manage your energy well throughout the day?</li><li>How to balance zest with wisdom and prudence?</li><li>How to cultivate tranquil energy and enthusiasm</li><li>How to prevent overexcitement leading to overpromising and underdelivering?</li><li>How to figure out your optimal energy levels for different tasks?</li><li>How to become more grounded, stable, and steady emotionally?</li><li>How to be aware of your own energy levels in order not to deplete yourself too much? (e.g., starting strong is good, but finishing strong is much more important)</li><li>How to avoid expressing too much energy and enthusiasm that might feel inappropriate to others?</li><li>How to make your enthusiasm more grounded and calm?</li><li>How to adjust your energy level when other people are in a less enthusiastic and energetic state?</li><li>How to deal with disappointment if a project you’ve been enthusiastic about didn’t work out and what to learn from this?</li><li>How to avoid draining other people’s energy with your enthusiasm?</li><li>How to combine enthusiasm, strategic thinking, and sound prioritisation?</li><li>How to know when mirroring someone's emotions and states is more appropriate than being energetic and enthusiastic?</li><li>How to combine enthusiasm with seriousness to ensure that your competence is not belittled?</li><li>How to channel enthusiasm in a positive direction by focusing on the most important goals instead of “getting things done”?</li><li>How to better manage impulsive behaviour?</li><li>How to maintain your enthusiasm in times of setbacks and disappointments?</li><li>How to become less reckless with decisions and actions during periods of high enthusiasm?</li><li>How to be more aware of the situations where you might want to tone down your zest and enthusiasm?</li><li>How to know when less enthusiasm is required, and a more neutral attitude is called for? (e.g., in a serious business meeting)</li><li>How to prevent enthusiasm from taking away the necessary focus and discipline?</li></ol><p>What actions lead to progress here?</p><ol><li>Keep a journal to collect situations with other people where your energy and enthusiasm were not well-calibrated to the emotional state of the other person</li><li>Reflect on past situations where (1) you were too enthusiastic about something and (2) this enthusiasm led to negative consequences</li><li>Remind yourself that disappointment (and enthusiasm) is a fleeting feeling</li><li>Learn to appreciate less enthusiastic or energetic states, so you become more state independent</li><li>Observe the energy and enthusiasm of others before speaking or acting to modulate your level</li><li>Analyze the project that you’ve been enthusiastic about but didn’t work out and examine how those experiences can improve your future decision-making</li><li>When you are in a high energy and enthusiasm state, try to add some grounded and calm energy </li><li>Start an energy and enthusiasm log to see if you calibrated them well throughout the day</li><li>Become more aware of the relationship between your enthusiasm, professionalism, and perceived competence</li><li>Create a list of situations where being more neutral and sober would have been more useful</li><li>Specify the level of energy you prefer for different tasks: low, medium, high? Which task works best with which level? Why? </li><li>Make a list of “reckless” decisions from the past that could have been made more prudently if you had toned down your zest and enthusiasm </li><li>Design a system that helps you decide when it is better to be more neutral than very excited about something</li><li>Make it a habit to evaluate your decisions after 3 days if they were based on high levels of energy and enthusiasm </li><li>Reflect on past situations where your enthusiasm has led to overpromising and underdelivering</li><li>Create a list of situations where more neutral and grounded energy is called for (1) at work, (2) when interacting with family members, and (3) when socializing with friends</li><li>List more consequences of an overly enthusiastic attitude: (1) you might not be taken seriously as a competent professional, (2) your expectations might have been set too high for yourself or others, which is draining and demotivating over time, (3) your decisions might have been based on insufficient information leading to poor choices</li><li>Create two categories: one for things that are important but not urgent/immediate/time-sensitive and one for things that are urgent/immediate/time-sensitive. Keep the former in mind when feeling overexcited. For the latter case make sure that they get done in a timely manner without compromising quality </li><li>Consider a “calm energy” training where you focus on cultivating more serenity, stability, and equanimity</li><li>Read more about managing energy like this article: How To Manage Your Energy</li></ol><p><br></p>",
      detailedDescription: [
        "Your moderate score indicates that you might be more often affectionate, pleasant, and hospitable than cold, insincere, and disagreeable. \n\nYou often believe that you can trust your friends, and they know they can trust you too. You experience many warm and trusting relationships with others and sometimes maintain close friendships through the years. Once in a while, you enjoy personal and mutual conversations with family members or friends. \n\nOther people might often feel warm when they interact with you. You might have strong feelings of empathy and affection in your relationships and value the importance of having positive relations with others. You might tend to value and emphasize the achievement of close unions with others and also guide them from time to time.",
      ],
      detailedDescriptionDetails: [
        {
          createdAt: "2022-07-14T10:22:02.106Z",
          heading: "What might be potential growth areas / blind spots?",
          points: [
            "How to have positive relationships with the people around you?",
            "How to develop empathy when listening to other people’s concerns?",
            "How to maintain close relationships with others through the years?",
            "How to take care of yourself while allowing yourself to be a thoughtful person?",
            "How to express your affection in your relationship…d deepen your connection with family and friends?",
          ],
          updatedAt: "2022-07-14T10:22:02.106Z",
          _id: "62cfee4afdcd13520118c580",
        },
        {
          createdAt: "2022-07-14T10:22:02.106Z",
          heading:
            "What actions lead to progress in potential growth areas / blind spots?",
          points: [
            "Talk to a friend about the things that can deepen your relationship with them",
            "Learn more about establishing a deeper connection with others",
            "Reflect on your past experiences when being able to open up to others benefited you",
            "Cut out unhealthy and toxic relationships that prevent you from maintaining positive relationships",
            "Listen to a podcast about relationships",
          ],
  
          updatedAt: "2022-07-14T10:22:02.106Z",
          _id: "62cfee4afdcd13520118c581",
        },
      ],
      growthFavorites: [
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
      ],
      percent: 90.17857142857143,
      questionCategory: "Self-acceptance",
      questionCategoryId: "gqinzVK5jnswksY9gz3Jtn25",
    },
    {
      actionFavorites: [
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-09T16:44:17.638Z",
          point:
            "Learn to appreciate less enthusiastic or energetic states, so you become more state independent",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "ACTION",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-09T16:44:17.638Z",
          _id: "63bc4461fec027cb7857280e",
        },
      ],
      description: [
        "This score indicates your current tendency to be warm, sociable, and friendly as opposed to being shy, distant, and unfriendly. It measures how consistently you do actions like appreciating others, hugging or other forms of physical gestures, or making time to have deep conversations with friends and family.",
      ],
      descriptionDetails:
        "<p>What might be potential growth areas / blind spots?</p><ol><li>How to manage your energy well throughout the day?</li><li>How to balance zest with wisdom and prudence?</li><li>How to cultivate tranquil energy and enthusiasm</li><li>How to prevent overexcitement leading to overpromising and underdelivering?</li><li>How to figure out your optimal energy levels for different tasks?</li><li>How to become more grounded, stable, and steady emotionally?</li><li>How to be aware of your own energy levels in order not to deplete yourself too much? (e.g., starting strong is good, but finishing strong is much more important)</li><li>How to avoid expressing too much energy and enthusiasm that might feel inappropriate to others?</li><li>How to make your enthusiasm more grounded and calm?</li><li>How to adjust your energy level when other people are in a less enthusiastic and energetic state?</li><li>How to deal with disappointment if a project you’ve been enthusiastic about didn’t work out and what to learn from this?</li><li>How to avoid draining other people’s energy with your enthusiasm?</li><li>How to combine enthusiasm, strategic thinking, and sound prioritisation?</li><li>How to know when mirroring someone's emotions and states is more appropriate than being energetic and enthusiastic?</li><li>How to combine enthusiasm with seriousness to ensure that your competence is not belittled?</li><li>How to channel enthusiasm in a positive direction by focusing on the most important goals instead of “getting things done”?</li><li>How to better manage impulsive behaviour?</li><li>How to maintain your enthusiasm in times of setbacks and disappointments?</li><li>How to become less reckless with decisions and actions during periods of high enthusiasm?</li><li>How to be more aware of the situations where you might want to tone down your zest and enthusiasm?</li><li>How to know when less enthusiasm is required, and a more neutral attitude is called for? (e.g., in a serious business meeting)</li><li>How to prevent enthusiasm from taking away the necessary focus and discipline?</li></ol><p>What actions lead to progress here?</p><ol><li>Keep a journal to collect situations with other people where your energy and enthusiasm were not well-calibrated to the emotional state of the other person</li><li>Reflect on past situations where (1) you were too enthusiastic about something and (2) this enthusiasm led to negative consequences</li><li>Remind yourself that disappointment (and enthusiasm) is a fleeting feeling</li><li>Learn to appreciate less enthusiastic or energetic states, so you become more state independent</li><li>Observe the energy and enthusiasm of others before speaking or acting to modulate your level</li><li>Analyze the project that you’ve been enthusiastic about but didn’t work out and examine how those experiences can improve your future decision-making</li><li>When you are in a high energy and enthusiasm state, try to add some grounded and calm energy </li><li>Start an energy and enthusiasm log to see if you calibrated them well throughout the day</li><li>Become more aware of the relationship between your enthusiasm, professionalism, and perceived competence</li><li>Create a list of situations where being more neutral and sober would have been more useful</li><li>Specify the level of energy you prefer for different tasks: low, medium, high? Which task works best with which level? Why? </li><li>Make a list of “reckless” decisions from the past that could have been made more prudently if you had toned down your zest and enthusiasm </li><li>Design a system that helps you decide when it is better to be more neutral than very excited about something</li><li>Make it a habit to evaluate your decisions after 3 days if they were based on high levels of energy and enthusiasm </li><li>Reflect on past situations where your enthusiasm has led to overpromising and underdelivering</li><li>Create a list of situations where more neutral and grounded energy is called for (1) at work, (2) when interacting with family members, and (3) when socializing with friends</li><li>List more consequences of an overly enthusiastic attitude: (1) you might not be taken seriously as a competent professional, (2) your expectations might have been set too high for yourself or others, which is draining and demotivating over time, (3) your decisions might have been based on insufficient information leading to poor choices</li><li>Create two categories: one for things that are important but not urgent/immediate/time-sensitive and one for things that are urgent/immediate/time-sensitive. Keep the former in mind when feeling overexcited. For the latter case make sure that they get done in a timely manner without compromising quality </li><li>Consider a “calm energy” training where you focus on cultivating more serenity, stability, and equanimity</li><li>Read more about managing energy like this article: How To Manage Your Energy</li></ol><p><br></p>",
      detailedDescription: [
        "Your moderate score indicates that you might be more often affectionate, pleasant, and hospitable than cold, insincere, and disagreeable. \n\nYou often believe that you can trust your friends, and they know they can trust you too. You experience many warm and trusting relationships with others and sometimes maintain close friendships through the years. Once in a while, you enjoy personal and mutual conversations with family members or friends. \n\nOther people might often feel warm when they interact with you. You might have strong feelings of empathy and affection in your relationships and value the importance of having positive relations with others. You might tend to value and emphasize the achievement of close unions with others and also guide them from time to time.",
      ],
      detailedDescriptionDetails: [
        {
          createdAt: "2022-07-14T10:22:02.106Z",
          heading: "What might be potential growth areas / blind spots?",
          points: [
            "How to have positive relationships with the people around you?",
            "How to develop empathy when listening to other people’s concerns?",
            "How to maintain close relationships with others through the years?",
            "How to take care of yourself while allowing yourself to be a thoughtful person?",
            "How to express your affection in your relationship…d deepen your connection with family and friends?",
          ],
          updatedAt: "2022-07-14T10:22:02.106Z",
          _id: "62cfee4afdcd13520118c580",
        },
        {
          createdAt: "2022-07-14T10:22:02.106Z",
          heading:
            "What actions lead to progress in potential growth areas / blind spots?",
          points: [
            "Talk to a friend about the things that can deepen your relationship with them",
            "Learn more about establishing a deeper connection with others",
            "Reflect on your past experiences when being able to open up to others benefited you",
            "Cut out unhealthy and toxic relationships that prevent you from maintaining positive relationships",
            "Listen to a podcast about relationships",
          ],
  
          updatedAt: "2022-07-14T10:22:02.106Z",
          _id: "62cfee4afdcd13520118c581",
        },
      ],
      growthFavorites: [
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
        {
          category: "Well-being",
          category_id: "fdqaqggF1pDWmnjURNvg1d",
          createdAt: "2023-01-04T10:04:20.207Z",
          point:
            "Reflect on past situations where your enthusiasm has led to overpromising and underdelivering",
          questionCategory: "Positive Relations",
          questionCategoryId: "fmLd1PRzPdqX97W1pLRobC",
          subCategory: "Psychological well-being",
          subCategory_id: "ffFuA6Mmu93A7rS3XwPyUN",
          type: "GROWTH",
          uid: "CByv6rUaqcb6aKHvdX1FOSdAHal1",
          updatedAt: "2023-01-04T10:04:20.207Z",
          __v: 0,
          _id: "63b54f24bb36c7c4fa2313b3",
        },
      ],
      percent: 90.17857142857143,
      questionCategory: "Self-acceptance",
      questionCategoryId: "gqinzVK5jnswksY9gz3Jtn27",
    },
  ]; 